export const encodeParams = ( params: Record<string, undefined | string | string[]> ) =>
{
    return Object.entries( params ).map( ( [ key, value ] ) =>
    {
        if ( !value ) return;
        if ( Array.isArray( value ) )
        {
            return value.map( val => `${key}=${encodeURIComponent( val )}` ).join( '&' );
        }
        return `${encodeURIComponent( key )}=${encodeURIComponent( value )}`;
    } ).filter( ( p ) => !!p ).join( '&' );
};